import { useMemo } from 'react';
import { createObjectNameMap, createObjectDescMap, createObjectCodeMap } from '../utils/objectDataUtils';

/**
 * Custom hook for creating object lookup maps
 * Provides efficient Map-based lookups for object data
 *
 * @param {Array} objectData - Array of object data from localStorage
 * @returns {Object} Object containing nameMap, descMap, and codeMap
 */
export const useObjectMaps = (objectData) => {
  const nameMap = useMemo(() => createObjectNameMap(objectData), [objectData]);
  const descMap = useMemo(() => createObjectDescMap(objectData), [objectData]);
  const codeMap = useMemo(() => createObjectCodeMap(objectData), [objectData]);

  return {
    nameMap,
    descMap,
    codeMap,
  };
};

/**
 * Hook that only creates the name map (most common use case)
 * @param {Array} objectData - Array of object data from localStorage
 * @returns {Map} Map with idObject as key and name as value
 */
export const useObjectNameMap = (objectData) => {
  return useMemo(() => createObjectNameMap(objectData), [objectData]);
};

/**
 * Hook that only creates the description map
 * @param {Array} objectData - Array of object data from localStorage
 * @returns {Map} Map with idObject as key and description as value
 */
export const useObjectDescMap = (objectData) => {
  return useMemo(() => createObjectDescMap(objectData), [objectData]);
};

/**
 * Hook that only creates the code map
 * @param {Array} objectData - Array of object data from localStorage
 * @returns {Map} Map with code as key and full object as value
 */
export const useObjectCodeMap = (objectData) => {
  return useMemo(() => createObjectCodeMap(objectData), [objectData]);
};
